/* COMPONENTS */
import PricingBanner from "components/pricing/banner";
import Plans from "components/pricing/plans";
import FrequentlyAskedQuestions from "components/common/faqs";
import CallToAction from "components/common/cta";

const Pricing = () => {
  return (
    <section className="p-0">
      {/* BANNER */}
      <PricingBanner />

      {/* PRICING PLANS */}
      <Plans />

      {/* FAQ'S SECTION */}
      <FrequentlyAskedQuestions />

      {/* CALL TO ACTION */}
      <CallToAction />
    </section>
  );
};

export default Pricing;
